import {Tab} from "@headlessui/react";
import {useEffect, useState} from "react";
import classNames from "classnames";
import apiData from "lib/stores/apiData";
import context from "lib/stores/context";
import api from "lib/api";
import {useSnapshot} from "valtio";
import styles from "./index.module.scss";
import DataPanelWrapper from "./DataPanelWrapper";

export default function RecommendationsPanel() {
  const {countries} = useSnapshot(apiData, {sync: true});
  const {activeCountry, activeTabCountries} = useSnapshot(context, {sync: true});

  useEffect(() => {
    getCountryData();
  }, [activeCountry]);

  const getCountryData = async () => {
    if (apiData.countries[activeCountry].fetched) return;
    const countryData = await api.GetCountry(activeCountry);
    apiData.countries[activeCountry].recommendations = countryData.recommendations;
    apiData.countries[activeCountry].recommendations_date = countryData.recommendations_date;
    apiData.countries[activeCountry].documents = [...countryData.documents];
    apiData.countries[activeCountry].links = [...countryData.links];
    apiData.countries[activeCountry].fetched = true;
  };

  const renderRecommendationItems = () => {
    try {
      return <RecommendationItems/>;
    } catch (error) {
      return null;
    }
  };

  const isMounted = () => {
    if (activeTabCountries === 0 && apiData.countries[activeCountry].recommendations) return true;
    return false;
  };

  return <Tab.Panel className={`relative pt-5`}>{renderRecommendationItems()}</Tab.Panel>;
}

const RecommendationItems = () => {
  const {countries} = useSnapshot(apiData);
  const {activeCountry, activeTabCountries} = useSnapshot(context);
  const [hidden, setHidden] = useState(true);

  useEffect(() => {
    setHidden(true);
    const timeout = setTimeout(() => {
      setHidden(false);
    }, 200);
    return () => {
      clearTimeout(timeout);
    };
  }, [activeCountry]);

  function extractRecommendations(str) {
    const regex = /<recommendation>(.*?)<\/recommendation>/g;
    let match;
    const recommendations = [];

    while ((match = regex.exec(str)) !== null) {
      recommendations.push(match[1]);
    }

    return recommendations;
  }

  const renderRecommendations = () => {
    let recs = countries[activeCountry].recommendations;
    if (recs) {
      recs = extractRecommendations(recs);
      return recs.map((rec, index) => {
        return (
          <div className={classNames(styles["recommendation-wrapper"])} key={index}>
            <p className={classNames(styles["recommendation-index"])}>{index + 1}</p>
            <div className={classNames(styles["recommendations-body-container"])}>
              <p className="text-left">{rec}</p>
            </div>
          </div>
        );
      });
    }
    return null;
  };

  const renderAsterisk = () => {
    return (<svg className="inline-block" xmlns="http://www.w3.org/2000/svg" width="8" height="7.69" viewBox="0 0 12 11.54"><path fill="currentColor" d="m7.27 1.33c0 .6-.24 1.69-.51 2.97l-.23 1.19 1.07-.58c1.53-.91 2.6-1.44 3.22-1.44s1.19.48 1.19 1.27c0 1.21-1.45 1.41-3.94 1.62l-1.21.14.9.85c1.6 1.41 2.46 2.17 2.46 3.03 0 .63-.56 1.17-1.21 1.17-1.08 0-1.61-1.3-2.48-3.32l-.53-1.1-.52 1.1c-.92 2.16-1.49 3.31-2.5 3.31-.66 0-1.2-.56-1.2-1.17 0-.91.98-1.71 2.47-3.02l.9-.85-1.2-.14c-2.59-.2-3.93-.45-3.93-1.63 0-.79.57-1.27 1.21-1.27.76 0 1.77.61 3.2 1.45l1.07.58-.23-1.19c-.3-1.32-.48-2.41-.48-2.97 0-.81.46-1.33 1.24-1.33s1.27.51 1.27 1.33Z"/></svg>);
  }

  const renderRecommendationsDate = () => {
    if (countries[activeCountry].recommendations_date) {
      const date = new Date(countries[activeCountry].recommendations_date)
      if (!isNaN(date.getTime())) {
        const dateString = date.toLocaleDateString(undefined, {day: 'numeric', month: 'long', year: 'numeric'});
        return (<div className="flex flex-row justify-start items-start gap-1 text-sm"><p><sup>{renderAsterisk()}</sup></p><p className="text-sm">Recommendations are based on government response data current as of <span className="whitespace-nowrap">{dateString}</span>.</p></div>);
      }
    }
    return null;
  }
  const renderRecommendationsDateSuper = () => {
    if (countries[activeCountry].recommendations_date) {
      if (!isNaN((new Date(countries[activeCountry].recommendations_date)).getTime())) {
        return (<sup>{renderAsterisk()}</sup>);
      }
    }
    return null;
  }

  return (
    <div
      className={`transition relative duration-500 ease-out lg:pb-[1.5rem] pb-[1.5rem] md:px-0 px-[1.35rem] w-full flex flex-col items-start justify-start pr-[2rem] source space-y-3 recommendations-block text-[14px] ${
        hidden && countries[activeCountry].recommendations ? "opacity-0 -translate-x-5 transition-none" : ""
      }`}
    >
      <p className={classNames(["recommendations-intro-copy-container", "text-base source"])}>
        Below is a list of high priority recommendations{renderRecommendationsDateSuper()} to be actioned by the government:
      </p>
      <div className="">{renderRecommendations()}</div>
      {renderRecommendationsDate()}
    </div>
  );
};
